import React from 'react';
import useQuery from '../../utilities/use-query';
import {useLocation, useNavigate} from 'react-router-dom';
import {useOperatorDispatch} from './operator-interface';
import searchFilter from '../../utilities/search-filter';

const serviceIdEx = process.env.RAZZLE_APP_SERVICE_ID;

const Start = () => {
    const {serviceId = serviceIdEx} = useQuery();
    const location = useLocation();
    const dispatch = useOperatorDispatch();
    const navigate = useNavigate();
    React.useEffect(() => {
        dispatch({type: 'start', payload: {serviceId}});
        navigate(`/operator-interface${searchFilter(location.search)}`, {replace: true});
    });
    return (
        <></>
    );
};

export default React.memo(Start);